import { Spin } from 'antd'
import React from 'react'

const spinnerStyle = {
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  width: '100%',
}
interface LoadProps {
  load?: any
}
const Load: React.FC<LoadProps> = ({ load }): JSX.Element => {
  if (load) {
    return (
      <div style={spinnerStyle}>
        <Spin />
      </div>
    )
  }

  return null
}

export default Load
